export const AssetGroupUrl = () => {
  return `api/mobopro/v1/assets/groups`
}

export const GetAssetGroupsUrl = (onlyactive) => {
  return `api/mobopro/v1/assets/groups?onlyactive=${onlyactive}`;
};
export const DeleteAssetGroupUrl = (id) => {
  return `api/mobopro/v1/assets/groups/${id}`;
};

export const UpdateAssetGroupUrl = (id) => {
  return `api/mobopro/v1/assets/groups/${id}`;
};

export const GetAssetGroupByIdUrl = (id) => {
  return `api/mobopro/v1/assets/groups/${id}`;
};

export const AssetsClassesUrl = () => {
  return `api/mobopro/v1/assets/classes`
}

export const GetAssetClassesUrl = (groupId) => {
  if (groupId) {
    return `api/mobopro/v1/assets/classes?includeall=true&group=${groupId}`;
  }
  return `api/mobopro/v1/assets/classes?includeall=true`;
};
export const DeleteAssetClassUrl = (id) => {
  return `api/mobopro/v1/assets/classes/${id}`;
};

export const UpdateAssetClassUrl = (id) => {
  return `api/mobopro/v1/assets/classes/${id}`;
};

export const GetAssetClassByIdUrl = (id) => {
  return `api/mobopro/v1/assets/classes/${id}`;
};

export const GetTraitsUrl = () => {
  return `api/mobopro/v1/traits`;
};

export const TraitsUrl = () => {
  return `api/mobopro/v1/traits`;
};

export const GetTraitByIdUrl = (id) => {
  return `api/mobopro/v1/traits/${id}`;
};

export const UpdateTraitUrl = (id) => {
  return `api/mobopro/v1/traits/${id}`;
};

export const DeleteTraitUrl = (id) => {
  return `api/mobopro/v1/traits/${id}`;
};

export const OutletUsersExternalCredentialsUrl = () => {
  return `api/mobopro/v1/outletusers/externalcredentials`
}

export const OutletUsersExternalCredentialsWithIdUrl = (id) => {
  return `api/mobopro/v1/outletusers/externalcredentials?id=${id}`
}

export const DeleteOutletUserExternalCredentialsUrl = (id) => {
  return `api/mobopro/v1/outletusers/externalcredentials/${id}`;
};

export const RevealOutletUserExternalCredentialsUrl = (id) => {
  return `api/mobopro/v1/outletusers/externalcredentials/password/${id}`;
}

export const MediaFilesSasUrl = () => {
  return `/api/mobopro/v1/mediafiles/sas`
}

export const OutletUserRolesUrl = () => { 
  return `/api/mobopro/v1/outletuserroles`
}

export const OutletUserPermissionsUrl = () => { 
  return `/api/mobopro/v1/outletuserpermissions`
}

export const OutletUserOutletsUrl = () => { 
  return `/api/mobopro/v1/outletuseroutlets`
}

export const OutletUserUrl = () => { 
  return `/api/mobopro/v1/outletuser`
}

export const OutletUserRolesAndPermissionsUrl = () => { 
  return `/api/mobopro/v1/outletuserrolesandpermissions`
}

export const OutletUserDossierStackAccessUrl = () => { 
  return `/api/mobopro/v1/outletuserdossierstackaccess`
}

export const OutletUserChatGroupsUrl = () => {
  return `/api/mobopro/v1/outletuserchatgroups`
}

export const SaveOutletUserImageUrl = (outletId) => {
  return `/api/mobopro/v2/outletusers/${outletId}/image`;
};
export const DeleteOutletUserImageUrl = (outletId) => {
  return `/api/mobopro/v1/outletuser/${outletId}/image`;
};
export const GetOutletUserUrl = (outletUserId) => {
  return `/api/mobopro/v1/outletuser/${outletUserId}`;
};

export const PinUrl = () => {
  return `/api/mobopro/v1/pin`
}

export const ResetPasswordUrl = (id) => {
  return `/api/mobopro/v1/passwordreset/${id}`;
};
export const UpdatePasswordUrl = (id) => {
  return `/api/mobopro/v1/updatepassword/${id}`;
};

export const CurrentIdentityUrl = () => {
  return `/api/mobopro/v1/currentidentity`
}

export const InitializeWithCultureCode = (culture) => {
  return `/api/mobopro/v1/initialize?cultureCode=${culture}`
}

export const InternalChatGroupsUrl = () => {
  return `/api/mobopro/v1/internalchatgroups`
}

export const InternalChatGroupsWithIdUrl = (id) => {
  return `/api/mobopro/v1/internalchatgroups/${id}`
}

export const SignableDocumentsWithOutletIdUrl = (outletId) => {
  if(outletId) {
    return `/api/mobopro/v1/signableDocuments?outletId=${outletId}`
  }

  return `/api/mobopro/v1/signableDocuments`;
}

export const SignableDocumentsUrl = () => {
  return `/api/mobopro/v1/signableDocuments`
}

export const  SignableDocumentByIdUrl = (id) => {
  return `/api/mobopro/v1/signableDocuments/${id}`
}

export const MoboOutletBlockedDaysUrl = () => {
  return `/api/mobopro/v1/mobooutletblockeddays`
}

export const MoboOutletBlockedDaysWithIdUrl = (id) => {
  return `/api/mobopro/v1/mobooutletblockeddays/${id}`
}

export const BookingWaitSlotsWithOutletIdAndDayIdUrl = (outletId, dayId) => {
  return `/api/mobopro/v1/bookingwaitslots/${outletId}/${dayId}`
}

export const OutletUsersUrl = () => {
  return `/api/mobopro/v1/outletusers`
}

export const OutletUserWithIdUrl = (id) => {
  return `/api/mobopro/v1/outletuser/${id}`
}

export const UndeletedOutletUserWithIdUrl = (id) => {
  return `/api/mobopro/v1/undeleteoutletuser/${id}`
}

export const EventTaskWorkflowsWithIdUrl = (id) => {
  return `/api/mobopro/v1/eventtasks/workflows/${id}`
}

export const EventTaskWorkflowsOutletsAndBrandsUrl = (id) => {
  return `/api/mobopro/v1/eventtasks/workflows/${id}/outletsandbrands`
}

export const EventTaskWorkflowsTriggersAndConditionsUrl = () => {
  return `/api/mobopro/v1/eventtasks/workflows/triggersandconditions`
}

export const OutletUsersNotDeletedUrl = () => {
  return `/api/mobopro/v1/outletusers?includedeleted=false`
}

export const ActiveInternalChatGroupsUrl = () => {
  return `/api/mobopro/v1/internalchatgroups?includenonactive=false&usage=TASKS`
}

export const EventTaskWorkflowsUrl = () => {
  return `/api/mobopro/v1/eventtasks/workflows`
}

export const EventTaskWorkflowsWithConditionsAndTextsWithIdUrl = (id) => {
  return `/api/mobopro/v1/eventtasks/workflows/${id}/conditionsandtexts`
}

export const EventTaskWorkflowsWithConditionsAndTextsWithIdAndQueryParamsUrl = (taskWorkflowId, ids) => {
  return `/api/mobopro/v1/eventtasks/workflows/${taskWorkflowId}/conditionsandtexts?istext=true&id=${ids}`
}

export const EventTaskWorkflowsWithConditionsAndTextsWithIdAndQueryParamsWithIsTextFalseUrl = (taskWorkflowId, ids) => {
  return `/api/mobopro/v1/eventtasks/workflows/${taskWorkflowId}/conditionsandtexts?istext=false&id=${ids}`
}

export const EventTaskWorkflowsWithOutletIdUrl = (id) => {
  return `/api/mobopro/v1/eventtasks/workflows?outletid=${id}`
}

export const PaymentConnectionsUrl = () => {
  return `/api/mobopro/v1/payments/connections`
}

export const PaymentConnectionsWithCompanyIdUrl = (id) => {
  return `/api/mobopro/v1/payments/connect?moboCompanyId=${id}`
}

export const ChatMessageTriggersUrl = () => {
  return `/api/mobopro/v1/chatmessagetriggers`
}

export const ChatMessageTriggersWithIdUrl = (id) => {
  return `/api/mobopro/v1/chatmessagetriggers/${id}`
}

export const BookingDateMarkersUrl = () => {
  return `/api/mobopro/v1/bookingdatemarkers`
}

export const BookingDateMarkersWithOutletIdAndYearUrl = (id, year) => {
  return `/api/mobopro/v1/bookingdatemarkers?outletid=${id}&year=${year}`
}

export const BookingDateMarkersWithIdUrl = (id) => {
  return `/api/mobopro/v1/bookingdatemarkers/${id}`
}

export const BookingItemsUrl = () => {
  return `/api/mobopro/v1/bookingitems`
}

export const BrandsWithObjectTypeUrl = (objectType) => {
  return `/api/mobopro/v1/brands?objectType=${objectType}`
}

export const BookingItemsWithMoboOutletIdUrl = (id) => {
  return `/api/mobopro/v1/bookingitems?moid=${id}&issettings=true`
}

export const BookingItemsWithIdUrl = (id) => {
  return `/api/mobopro/v1/bookingitems/${id}`
}

export const BookingItemsCopyUrl = () => {
  return `/api/mobopro/v1/bookingitems/copy`
}

export const BookingWaitSlotUrl = () => {
  return `/api/mobopro/v1/bookingwaitslot`
}

export const BookingWaitSlotsWithIdUrl = (id) => {
  return `/api/mobopro/v1/bookingwaitslots/${id}`
}

export const BookingWaitSlotWithIdUrl = (id) => {
  return `/api/mobopro/v1/bookingwaitslot/${id}`
}

export const BookingWaitSlotsUrl = () => {
  return `/api/mobopro/v1/bookingwaitslots`
}

export const DossierStacksUrl = () => {
  return `/api/mobopro/v1/dossierstacks`
}

export const DossierStacksWithIdUrl = (id) => {
  return `/api/mobopro/v1/dossierstacks/${id}`
}

export const DossierStacksWithIsSettingsTrueUrl = () => {
  return `/api/mobopro/v1/dossierstacks?isSettings=true`
}

export const MoboOutletMobilitySolutionsUrl = () => {
  return `/api/mobopro/v1/mobooutletmobilitysolutions`
}

export const MoboOutletMobilitySolutionsWithIdUrl = (id) => {
  return `/api/mobopro/v1/mobooutletmobilitysolutions/${id}/`
}

export const MoboOutletOpeningHoursWithIdUrl = (id) => {
  return `/api/mobopro/v1/mobooutletopeninghours?id=${id}`
}

export const MoboOutletOpeningHoursByOutletIdUrl = (id) => {
  return `/api/mobopro/v1/mobooutletopeninghours/${id}`
}

export const MoboOutletOpeningHoursUrl = () => {
  return `/api/mobopro/v1/mobooutletopeninghours`
}

export const PauseReasonsUrl = () => {
  return `/api/mobopro/v1/pausereasons`
}

export const PauseReasonsWithIdUrl = (id) => {
  return `/api/mobopro/v1/pausereasons/${id}`
}

export const SnippetsUrl = () => {
  return `/api/mobopro/v1/snippets`
}

export const SnippetsWithIdUrl = (id) => {
  return `/api/mobopro/v1/snippets/${id}`
}

export const TagsUrl = () => {
  return `/api/mobopro/v2/tags`
}

export const TagsWithIdUrl = (id) => {
  return `/api/mobopro/v2/tags/${id}`
}

export const TagsWithTypeUrl = (type) => {
  return `/api/mobopro/v2/tags?type=${type}`
}

export const TagsWithIdV1Url = (id) => {
  return `/api/mobopro/v1/tags/${id}`
}

export const PlanningAbsencesUrl = () => {
  return `/api/mobopro/v1/planningabsences`
}

export const OutletUserTimetableDetailsWithOutletUserIdOutletIdAndDateUrl = (outletUserId, outletId, date) => {
  return `/api/mobopro/v1/outletusertimetabledetails?ouid=${outletUserId}&moid=${outletId}&requestedDate=${date}`
}

export const AbsenceTypesUrl = () => {
  return `/api/mobopro/v1/absencetypes`
}

export const PlanningWithIdUrl = (id) => {
  return `/api/mobopro/v1/planning/${id}`
}

export const PlanningAbsencesWithDateFromAndDateTillUrl = (dateFrom, dateTill) => {
  return `/api/mobopro/v1/planningabsences?dateFrom=${dateFrom}&dateTill=${dateTill}`
}

export const AbsenceTypesWithIdUrl = (id) => {
  return `/api/mobopro/v1/absencetypes/${id}`
}

export const WorkshopAgendasWithIdUrl = (id) => {
  return `/api/mobopro/v1/workshopagendas/${id}`
}

export const WorkshopAgendasUrl = () => {
  return `/api/mobopro/v1/workshopagendas`
}

export const WorkshopTimetablesUrl = () => {
  return `/api/mobopro/v1/workshoptimetables`
}

export const WorkshopPlanningIndicatorsUrl = () => {
  return `/api/mobopro/v1/workshopplanningindicators`
}

export const WorkshopPlanningIndicatorsWithIdUrl = (id) => {
  return `/api/mobopro/v1/workshopplanningindicators/${id}`
}

export const WorkshopPlanningIndicatorsWithOutletIdUrl = (id) => {
  return `/api/mobopro/v1/workshopplanningindicators?moid=${id}`
}

export const LinkedWorkshopAgendasWithOutletIdUrl = (id) => {
  return `/api/mobopro/v1/linkedworkshopagendas?moid=${id}`
}

export const LinkedWorkshopAgendasUrl = () => {
  return `/api/mobopro/v1/linkedworkshopagendas`
}

export const LinkedWorkshopAgendasWithIdUrl = (id) => {
  return `/api/mobopro/v1/linkedworkshopagendas/${id}`
}

export const WorkshopPlanningIndicatorsWithOutletIdAndIsCompetenceTrueUrl = (id) => {
  return `/api/mobopro/v1/workshopplanningindicators?moid=${id}&isCompetence=true`
}

export const WorkshopPlanningIndicatorsToOutletUsersUrl = () => {
  return `/api/mobopro/v1/workshopplanningindicatorstooutletusers`
}

export const WorkshopPlanningIndicatorsToOutletUsersWithOutletIdUrl = (id) => {
  return `/api/mobopro/v1/workshopplanningindicatorstooutletusers?moid=${id}`
}

export const WorkshopPlanningIndicatorsToOutletUsersWithIdUrl = (id) => {
  return `/api/mobopro/v1/workshopplanningindicatorstooutletusers/${id}`
}

export const WorkshopAvailabilityRatiosWithIdUrl = (id) => {
  return `/api/mobopro/v1/workshopavailabilityratios/${id}`
}

export const WorkshopAvailabilityRatiosUrl = () => {
  return `/api/mobopro/v1/workshopavailabilityratios`
}

export const WorkshopAvailabilityRatiosWithOutletIdUrl = (id) => {
  return `/api/mobopro/v1/workshopavailabilityratios?moid=${id}`
}

export const PlanningTeamMembersUrl = () => {
  return `/api/mobopro/v1/planningteammembers`
}

export const PlanningTeamMembersWithIdUrl = (id) => {
  return `/api/mobopro/v1/planningteammembers/${id}`
}

export const PlanningTeamsWithIdUrl = (id) => {
  return `/api/mobopro/v1/planningteams/${id}`
}

export const PlanningTeamsUrl = () => {
  return `/api/mobopro/v1/planningteams`
}

export const WorkshopTimetablesWithIdUrl = (id) => {
  return `/api/mobopro/v1/workshoptimetables/${id}`
}

export const WorkPreparationMoboOutletsRolesUrl = () => {
  return `/api/mobopro/v1/workpreparations/mobooutletroles`
}

export const WorkPreparationRolesUrl = () => {
  return `/api/mobopro/v1/workpreparations/roles`
}

export const WorkPreparationMoboOutletRolesWithIdUrl = (id) => {
  return `/api/mobopro/v1/workpreparations/mobooutletroles/${id}`
}

export const APP_NAME = 'Settings';

export const AuthenticationTypeWithEmailUrl = (email) => {
  return `/api/mobopro/v1/authenticationtype?email=${email}`
}

export const AuthenticateUrl = () => {
  return `/api/mobopro/v1/authenticate`
}

export const AuthenticateAdUrl = () => {
  return `/api/mobopro/v1/authenticate/ad`
}

export const AuthenticateOktaUrl = () => {
  return `/api/mobopro/v1/authenticate/okta`
}

export const MoboOutletDisclaimersWithOutletIdUrl = (id) => {
  return `/api/mobopro/v1/mobooutletdisclaimers?moboOutletId=${id !== 0 ? `${id}` : ""}`
}

export const MoboOutletDisclaimersCopyUrl = () => {
  return `/api/mobopro/v1/mobooutletdisclaimers/copy`
}

export const MoboOutletDisclaimersWithIdUrl = (id) => {
  return `/api/mobopro/v1/mobooutletdisclaimers/${id}`
}

export const MoboOutletDisclaimersUrl = () => {
  return `/api/mobopro/v1/mobooutletdisclaimers`
}

export const SnippetsV2Url = () => {
  return `/api/mobopro/v2/snippets`
}

export const ChecklistManagementBaseUrl = () => {
  return `/api/mobopro/v1/checklistmanagement/templates`
}

export const WheelLocationsUrl = () => {
  return `/api/mobopro/v1/wheellocations`
}

export const WheelLocationsWithIdUrl = (id) => {
  return `/api/mobopro/v1/wheellocations/${id}`
}
export const FleetSourceUrl = () => {
    return `api/mobopro/v1/assets/fleetsources`
};

export const GetFleetSourcesUrl = () => {
    return `api/mobopro/v1/assets/fleetsources?includeall=false`;
};
export const DeleteFleetSourceUrl = (id) => {
  return `api/mobopro/v1/assets/fleetsources/${id}`;
};

export const UpdateFleetSourceUrl = (id) => {
  return `api/mobopro/v1/assets/fleetsources/${id}`;
};

export const GetFleetSourceByIdUrl = (id) => {
  return `api/mobopro/v1/assets/fleetsources/${id}`;
};

export const GetDriveBookingPartiesUrl = () => {
  return `api/mobopro/v1/assets/parties`;
};

export const GetPlanningSettingsUrl = (outletId) => {
  return `api/mobopro/v1/planning/settings?outletId=${outletId}`;
};
